import getIn from '../utils/getIn'
import isInApp from './isInApp'

class DataLayer {
    constructor () {
        const isResponsive = getIn('config.responsiveModeEnabled', window)
        let platform = 'desktop'
        Object.assign(this, {
            channel: 'B2C',
            platform,
            country: 'FR',
            language: 'fr',
            isResponsive,
            isMobile: platform === 'mobile',
            isInApp
        })
        this.ready = new Promise(resolve => {
            if (process.env.NODE_ENV === 'development') {
                this.populate()
                resolve(this)
            } else {
                const padlInterval = window.setInterval(() => {
                    if (getIn('padl.page.pageInfo', window) && getIn('padl.app', window)) {
                        window.clearInterval(padlInterval)
                        this.populate()
                        resolve(this)
                    }
                }, 50)
            }
        })
    }
    populate () {
        const dataLayer = window.padl
        const app = dataLayer.app
        const pageInfo = dataLayer.page.pageInfo
        const breadcrumbUID = pageInfo.breadcrumbUID
        let technology = breadcrumbUID.split(':')[4] || 'originalline'
        if (technology === 'originalline') {
            technology = 'original'
        } else if (technology === 'vertuoline') {
            technology = 'vertuo'
        }
        Object.assign(this, {
            isProd: app.isEnvironmentProd,
            currency: app.currency,
            breadcrumbUID,
            technology,
            pageName: pageInfo.pageName,
            isMosaic: app.landscape === 'NC2-mosaic' && !this.isResponsive,
            isMobile: app.landscape === 'NC2-mobile-site',
            isClassic: app.landscape === 'NC2-classic',
            deviceType: app.deviceType
        })
    }
}
export default new DataLayer()
